import { Component, OnInit } from '@angular/core';

import { StateMap, UnitOfWork, UserManager } from '../../services/common';
import * as _ from 'lodash';

import { ExposureSurveyMaterialMostRecent, RIFMReport } from '../../entities/EntityModels';
import { EXPOSURE_ROUTES } from './exposure.routes';

import {Observable, Subject} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Component({
    templateUrl: './exposure-survey-reports.html',
})
export class ExposureSurveyReportsComponent implements OnInit {
    public _exposureSurveyMostRecents: ExposureSurveyMaterialMostRecent[] = [];
    public _rifmReports: RIFMReport[] = [];

    _documentManagementUrl: string;
    _isLoading = false;
    _validationMessage: string;

    constructor(public _stateMap: StateMap, public _uow: UnitOfWork, public _userManager: UserManager, private _httpClient: HttpClient) {

    }

    ngOnInit() {
        this._stateMap.currentRouteName = EXPOSURE_ROUTES.ExposureSurveyReportsComponent.name;

        this.fetch();

        this._uow.getDocumentManagementUrl().then(url => {
            this._stateMap.documentManagementBaseUrl = url;
            this._documentManagementUrl = this._stateMap.documentManagementBaseUrl;
        });
    }

    // ***** RIFM Reports *****
    fetch() {
        const params = { reportTopic: 'ExposureSurveyReports' };
        return this._uow.fetch('Misc/RIFMReportsByReportTopic', params).then(r => {
            if (r) {
                this._rifmReports = _.sortBy(r, x => x.reportTitle);
            } else {
                this._rifmReports = r;
            }
        });
    }

    onShowRIFMReport(r: RIFMReport) {
        if (r.reportWebLink != null) {
            window.open(r.reportWebLink);
            return false;
        }

        if (r.reportFileName != null) {
            const fileParts = this.splitFileData(r.reportFileName);
            if (fileParts) {
                const endpointName = '/RIFMDownloadableFile/GetFileBySubFolderAndName?fileName=' + fileParts[1] + '&subFolder=' + fileParts[0] ;

                const ext = fileParts[1].split('.')[1];
                return (this.exportContentFile(endpointName, fileParts[1], ext));
            }
        }
        return false;
    }

    onShowMostRecentSurveyReport() {
        this._isLoading = true;

        return this._uow.fetch('ExposureSurveys/ExposureSurveyMaterialMostRecents', {}).then(r => {
            this._exposureSurveyMostRecents = r;
            if (this._exposureSurveyMostRecents != null && this._exposureSurveyMostRecents.length > 0) {
                this._isLoading = false;
                setTimeout(() => {
                    const ele = $('#ExposureSurveyLastReport');
                    (<any>ele).modal('show');
                }, 0);
                return;
            }
        });
    }

    onExportMaterialThresholdReport() {
        const endpointName = '/Report/GetExposureSurveyThresholdReportFile';

        return (this.exportContentFile(endpointName, 'ExposureSurveyMaterialThreshold.csv', 'csv'));
    }

    splitFileData(data: string) {
        if (!this.isValidString(data)) {
            return null;
        }
        const fileParts = data.split('/');
        if (fileParts != null && fileParts.length == 2) {
            return fileParts;
        }
        return null;
    }

    isValidString(teststring: string) {
        if (!teststring) { return false; }

        return (teststring.trim().length > 0);
    }

    // ************************************************************************
    // document management web api url
    // ************************************************************************
    getDownloadFileURL(endpointName: string): Observable<any> {
        let url: string;
        url = this._documentManagementUrl + endpointName;

        return this._httpClient.get<any>(url, { responseType: 'blob' as 'json'});
    }

    public exportContentFile(endpointName: string, fileName: string, fileType: string) {
        this._isLoading = true;
        this._validationMessage = '';
        this.getDownloadFileURL(endpointName)
            .subscribe(
                (response: Blob) => {
                    const data = response;

                    let file: Blob;
                    if (fileType == 'csv') {
                        file = new Blob([data], { type: 'text/plain;charset=utf-8;' });
                    } else {
                        file = new Blob([data], { type: 'application/pdf' });
                    }
                    const fileURL = URL.createObjectURL(file);

                    const a         = document.createElement('a');
                    a.href        = fileURL;
                    a.target      = '_blank';
                    a.download    = fileName;
                    document.body.appendChild(a);
                    a.click();

                    a.remove();

                    window.URL.revokeObjectURL(fileURL);

                    this._validationMessage = 'File download successful.';

                },
                (error) => {
                    console.error('Request failed with error: ' + error.message);
                    this._validationMessage = error.message;
                    this._isLoading = false;
                },
                () => {
                    this._isLoading = false;
                });
    }
}
